/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { InjectionToken, inject } from '@angular/core';

/** Possible positions for a tooltip. */
export type TooltipPosition = 'left' | 'right' | 'above' | 'below' | 'before' | 'after';

export type Point = { x: number; y: number };

export interface ModusTooltipOptions {
  showDelay: number;
  hideDelay: number;
  position: TooltipPosition;
  positionAtOrigin: boolean;
}

export const ModusTooltipDefaultOptions: ModusTooltipOptions = {
  showDelay: 100,
  hideDelay: 100,
  position: 'below',
  positionAtOrigin: false,
};

export const MODUS_TOOLTIP_DEFAULT_OPTIONS = new InjectionToken<ModusTooltipOptions>(
  'ModusTooltipDefaultOptions',
  {
    providedIn: 'root',
    factory: () => ModusTooltipDefaultOptions,
  },
);

export function modusTooltipScrollStrategyFactory(): () => ScrollStrategy {
  const overlay = inject(Overlay);
  return () => overlay.scrollStrategies.reposition();
}

export const MODUS_TOOLTIP_SCROLL_STRATEGY = new InjectionToken<() => ScrollStrategy>(
  'ModusTooltipScrollStrategy',
  { factory: modusTooltipScrollStrategyFactory },
);
